@if (progressText() || targetText()) {
  <div
    class="flex ms-small-b font-body-1 light-type font-body-medium"
    [ngClass]="{
      'flex--space-between': progressText() && targetText(),
      'flex--start': !targetText(),
      'flex--end': !progressText(),
    }"
    aria-hidden="true"
  >
    @if (progressText()) {
      <span>{{ progressText() }}</span>
    }
    @if (targetText()) {
      <span>{{ targetText() }}</span>
    }
  </div>
}
<div
  class="progress-indicator grey-200-bg surface-disabled relative"
  role="progressbar"
  aria-valuemin="0"
  aria-valuemax="100"
  [attr.aria-valuenow]="percentage()"
  [attr.aria-label]="ariaLabel()"
>
  <div
    [@fillGrow]="{ value: progressScaleX(), params: { progress: progressScaleX() } }"
    class="progress-fill relative {{ fillColor() }}"
  ></div>
</div>
<div class="flex flex--center ms-small-t font-body-1 light-type hide-empty font-body-medium">
  <ng-content />
</div>
